import {
  makeAccessibleButton,
  observeHeaderHeight,
  modifySearchBox,
  modifyFeatureLineup,
} from './utils.js';

// =====================================================
// Header / Navigation patches
// =====================================================

function modifyBtnNavToggle() {
  const navToggle = $('.mobile-nav-toggle');
  const closeToggle = $('.close-mobile-menu');

  if (!navToggle.length || navToggle.data('patched')) return;
  navToggle.data('patched', true);

  // Open menu → move focus inside when menu is actually open
  makeAccessibleButton(navToggle, 'Open menu', () => {
    requestAnimationFrame(() => {
      if ($('body').hasClass('mobile-menu-open') && closeToggle.length) {
        closeToggle.attr('tabindex', 0).focus();
      }
    });
  });

  // Close menu → return focus to toggle when menu is actually closed
  makeAccessibleButton(closeToggle, 'Close menu', () => {
    requestAnimationFrame(() => {
      if (!$('body').hasClass('mobile-menu-open')) {
        navToggle.focus();
      }
    });
  });
}

// =====================================================
// Weather widget patch
// =====================================================

function modifyWeatherBug() {
  const widget = document.getElementById('weatherBugWidget');
  const desc = document.getElementById('weatherBugDescription');
  if (!widget || !desc) return;

  const observer = new MutationObserver(() => {
    const text = desc.textContent.trim();
    if (!text || widget.classList.contains('weatherBugSet')) return;

    widget.classList.add('weatherBugSet');

    const lastSpace = text.lastIndexOf(' ');
    if (lastSpace !== -1) {
      desc.textContent = text.substring(lastSpace + 1);
    }

    observer.disconnect();
  });

  observer.observe(desc, { childList: true, subtree: true });
}

$(document).ready(() => {
  $('.generalmessage').prependTo('header');

  modifyBtnNavToggle();
  modifySearchBox();
  modifyFeatureLineup();
  modifyWeatherBug();
  makeAccessibleButton($('.close-mobile-menu'), 'Close menu');
  observeHeaderHeight('.header');
});
